export const blog = {
  title: "Blog",
  subtitle: "Mantenete al tanto de las novedades en nuestro blog",
  readMore: "Leer más",
  latestPosts: "Últimas publicaciones", // Or "Últimos posts"
};
